import * as React from 'react';

import { Text } from '@components/common';
import { GlobeSVG } from '@components/svgs';

interface Attachment {
  type: string;
  content: string;
}

interface Props {
  attachments?: Attachment[];
}

export const AttachmentsList = ({ attachments }: Props) => {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  return (
    <div className='flex items-center space-x-2'>
      {attachments.map((attachment) => (
        <div
          key={attachment.content}
          className='flex items-center space-x-1 rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-600'
        >
          <div className='max-w-40'>
            <div className='flex items-center space-x-1'>
              {attachment.type === 'prototype_url' ? (
                <img className='h-3 w-3 text-gray-500' src='/temp-assets/figma.png' alt='Figma icon' />
              ) : (
                <GlobeSVG className='h-3 w-3 text-gray-500' />
              )}
              <Text h='400' color='gray-600' className='truncate'>
                {attachment.content}
              </Text>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
